module.exports = __webpack_public_path__ + "img/invite_award_desc_title.bb7253be.png";